// Generate code from clean architecture template

import { CourseLineEntity } from '../entities';
import { CourseLinePayloadForm } from '../ports/payloads';
import { CourseLineRepository } from '../ports/repositories';

export class CreateCourseLineUsecase {
  constructor(private readonly repo: CourseLineRepository) {}

  async run(payload: CourseLinePayloadForm): Promise<CourseLineEntity> {
    const data = await this.repo.createCourseLine(payload);
    return data;
  }
}
